import { IFeedLeague } from '@/types';
import { FeedLiveItem } from '@/models/feedLive';
import { FeedPregameItem } from '@/models/feedPregame';

export function useFeedLeagueHandler(leagueItems: Ref<Record<number, IFeedLeague>>) {
    function clearFeedLeague(): void {
        leagueItems.value = {};
    }

    function addFeedLeague(feedLine: FeedLiveItem | FeedPregameItem): void {
        if (feedLine.leagueId.value in leagueItems.value) {
            leagueItems.value[feedLine.leagueId.value].eventsCount++;
        } else {
            const league: IFeedLeague = {
                id: feedLine.leagueId.value,
                name: feedLine.leagueName.value,
                iso3: feedLine.iso3.value,
                limitsCategoryId: feedLine.limitsCategoryId.value,
                rank: feedLine.leagueRank.value ?? 999,
                eventsCount: 1,
            };
            leagueItems.value[league.id] = league;
        }
    }

    function removeFeedLeague(feedLine: FeedLiveItem | FeedPregameItem): void {
        if (feedLine.leagueId.value in leagueItems.value && leagueItems.value[feedLine.leagueId.value].eventsCount > 1) {
            leagueItems.value[feedLine.leagueId.value].eventsCount--;
        } else {
            delete leagueItems.value[feedLine.leagueId.value];
        }
    }

    return {
        clearFeedLeague,
        addFeedLeague,
        removeFeedLeague,
    };
}
